<script setup lang="ts">
import Sidebar from '../sections/Sidebar.vue';
import EventCard from '../sections/EventCard.vue';
import HandCursor from '../sections/HandCursor.vue';

defineProps<{
  activeStep: number;
  isHeaderMenuOpen: boolean;
  showHand: boolean;
  handPos: { x: number; y: number };
}>();

defineEmits<{
  (e: 'update:activeStep', step: number): void;
}>();
</script>

<template>
  <div class="editor-main-parity-mock dark">
    <Sidebar :activeStep="activeStep" @update:activeStep="$emit('update:activeStep', $event)" />
    
    <main class="editor-content-parity dark">
      <div class="bet-builder-view-mock dark">
        <EventCard :isHeaderMenuOpen="isHeaderMenuOpen" @update:activeStep="$emit('update:activeStep', $event)" />
      </div>
      <HandCursor :show="showHand" :x="handPos.x" :y="handPos.y" />
    </main>
  </div>
</template>

<style scoped>
.editor-main-parity-mock { display: flex; height: 100%; min-height: 600px; }
.editor-content-parity { flex-grow: 1; padding: 12px; background: #111; display: flex; flex-direction: column; position: relative; }
.bet-builder-view-mock { flex-grow: 1; background: #000; border-radius: 20px; border: 1px solid rgba(255,255,255,0.05); padding: 24px; min-height: 500px; display: flex; flex-direction: column; justify-content: flex-start; }

@media (max-width: 768px) {
  .editor-main-parity-mock { flex-direction: column; min-height: 500px; }
  .editor-content-parity { padding: 0 16px 40px; background: #111; }
  .bet-builder-view-mock { padding: 0; border-radius: 0; border: none; background: transparent; }
}
</style>
